import { Grid } from "@mui/material";
import { FormikDatePicker, isValidDate } from "@shared";
import { FormikProps } from "formik";

import {
  ALL_COUNSELORS_OPTION_ID,
  FormikCounselorSelect,
} from "@/common/components/counselor-select/FormikCounselorSelect";
import { snapBackToAllOption } from "@/common/utils/allOption";
import { useTranslation } from "@/translations";

import { ExchangeHistoryFilterValues } from "../ExchangeHistoryPanel.types";

interface Props {
  formik: FormikProps<ExchangeHistoryFilterValues>;
}

/** Filter bar: from/till date window and the given-away-by / exchanged-with (Abgegeben von / Getauscht mit)
 *  counselor dropdowns. Filters apply live as the form values change. */
export function ExchangeHistoryFilterBar({ formik }: Props) {
  const { t } = useTranslation();
  const { fromDate } = formik.values;

  return (
    <Grid container columnSpacing={2} rowSpacing={1} sx={{ pt: 2 }}>
      <Grid size={{ xs: 12, sm: 6, md: 3 }}>
        <FormikDatePicker fieldName="fromDate" label={t("exchange.history.filter.from")} formik={formik} clearable />
      </Grid>
      <Grid size={{ xs: 12, sm: 6, md: 3 }}>
        <FormikDatePicker
          fieldName="tillDate"
          label={t("exchange.history.filter.till")}
          formik={formik}
          clearable
          minDate={isValidDate(fromDate) ? fromDate : undefined}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 6, md: 3 }}>
        <FormikCounselorSelect
          formik={formik}
          fieldName="givenAwayByCounselorId"
          label={t("exchange.history.filter.givenAwayBy")}
          includeAllOption
          onValueChange={snapBackToAllOption(formik, "givenAwayByCounselorId", ALL_COUNSELORS_OPTION_ID)}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 6, md: 3 }}>
        <FormikCounselorSelect
          formik={formik}
          fieldName="exchangedWithCounselorId"
          label={t("exchange.history.filter.exchangedWith")}
          includeAllOption
          onValueChange={snapBackToAllOption(formik, "exchangedWithCounselorId", ALL_COUNSELORS_OPTION_ID)}
        />
      </Grid>
    </Grid>
  );
}
